export function canApplyExploreFilters(input: {
  competitorOptionsReady: boolean;
  draftComplete: boolean;
  isOverviewRoute: boolean;
  overviewDirty: boolean;
  isDrilldownRoute: boolean;
  drilldownDirty: boolean;
  /** Drilldown draft joins a dimension rule to a metric rule with Or — the API rejects it. */
  hasDrilldownFilterLogicError: boolean;
}): boolean {
  if (!input.competitorOptionsReady) return false;
  if (input.isDrilldownRoute && input.hasDrilldownFilterLogicError) return false;
  return (
    input.draftComplete ||
    (input.isOverviewRoute && input.overviewDirty) ||
    (input.isDrilldownRoute && input.drilldownDirty)
  );
}

export type ExploreApplyDisableReason =
  | "incomplete"
  | "roster-loading"
  | "roster-error"
  | "filter-logic";

export function resolveExploreApplyDisableReason(input: {
  canApply: boolean;
  competitorOptionsReady: boolean;
  competitorBrandsError: boolean;
  competitorBrandsLoading: boolean;
  hasDrilldownFilterLogicError: boolean;
}): ExploreApplyDisableReason | undefined {
  if (input.canApply) return undefined;
  if (!input.competitorOptionsReady && input.competitorBrandsError) return "roster-error";
  if (!input.competitorOptionsReady && input.competitorBrandsLoading) return "roster-loading";
  if (input.hasDrilldownFilterLogicError) return "filter-logic";
  return "incomplete";
}
